export const loadCourseDetailPanel = () => import('./CourseDetailPanel.jsx');
